function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBaumIconEigen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 552",
    cx: 18,
    cy: 18,
    r: 18,
    style: {
      fill: "#26791c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 2784",
    d: "M4 22.424h2v2H4zm-4 2h2v-2H0zm12.056 0h2v-2h-2zm4 0h2v-2h-2zM9.983 21.07v3.33h-2v-3.33H.028v-2h7.955v-2.709c-3.911-.309-6.954-2.51-6.954-5.175a4.272 4.272 0 0 1 1.733-3.268 2.938 2.938 0 0 1-.175-.992A3.694 3.694 0 0 1 4.492 3.9a2.2 2.2 0 0 1-.151-.8c0-1.737 2.013-3.1 4.583-3.1s4.583 1.363 4.583 3.1a2.189 2.189 0 0 1-.15.794 3.7 3.7 0 0 1 1.9 3.028 2.937 2.937 0 0 1-.174.992 4.272 4.272 0 0 1 1.733 3.268c0 2.638-2.983 4.82-6.837 5.164v2.72h8.045v2zm-2-5.712v-3.663L5.692 9.4l.708-.7 1.584 1.584V9.056h2v3.023l1.532-1.531.707.707-2.24 2.238v1.854c3.3-.313 5.837-2.057 5.837-4.161a3.457 3.457 0 0 0-1.64-2.7.5.5 0 0 1-.151-.631 2.033 2.033 0 0 0 .232-.924 2.934 2.934 0 0 0-1.8-2.4.5.5 0 0 1-.183-.71 1.324 1.324 0 0 0 .228-.715c0-1.14-1.64-2.1-3.583-2.1s-3.583.964-3.583 2.1a1.317 1.317 0 0 0 .228.715.5.5 0 0 1-.182.71 2.935 2.935 0 0 0-1.8 2.4 2.034 2.034 0 0 0 .233.924.5.5 0 0 1-.151.631 3.457 3.457 0 0 0-1.64 2.7c0 2.129 2.6 3.89 5.954 4.172",
    transform: "translate(9.188 4.483)",
    style: {
      fill: "#f5f5f5"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBaumIconEigen);
export default __webpack_public_path__ + "static/media/Baum_Icon_Eigen.812d7a093fb1bec5cf79106619f45733.svg";
export { ForwardRef as ReactComponent };